import React from "react";
import "./button.css";

/**
 * This component is used on Brand Page
 */
function Button(props) {
  const { value, handleClick, icon = null,style,disabled,iconBefore } = props;

  return (
    
    <button onClick={handleClick} disabled={disabled} className="btn-container-register btn-brand-add" style={{...style,opacity:disabled?'0.5':'1'}}>
       {iconBefore && icon ? icon : null}
      {value}
      {!iconBefore && icon ? icon : null}
    </button>
  );
}

export default Button;
